export const fontFamily = {
  primary: 'Visuelt, sans-serif',
};
